export const getWidget = ({ type, preview }) => {
  if (preview === true) {
    switch (type) {
      case "SimpleTable":
        return "SimpleTable"
      case "CrossReferenceTable":
        return "CrossReferenceTable"
      case "ParticipantFlow":
        return "ParticipantFlow"
      case "BaselineCharacteristics":
        return "BaselineCharacteristics"
      case "OutcomeMeasures":
        return "OutcomeMeasures"
      case "AdverseEvents":
        return "AdverseEvents"
      case "TrialCountries":
        return "PopulationOfTrialPreview"
      case "AgeRange":
        return "AgeRangePreview"
      case "MemberStatesConcerned":
        return "MemberStatesConcerned"
      default:
        return "Preview"
    }
  }

  switch (type) {
    case "date":
      return "date"
    case "radio":
      return "radio"
    case "Lookahead":
      return "Lookahead"
    case "CustomCheckboxGroup":
      return "CustomCheckboxGroup"
    case "SimpleTable":
      return "SimpleTable"
    case "CrossReferenceTable":
      return "CrossReferenceTable"
    case "ParticipantFlow":
      return "ParticipantFlow"
    case "BaselineCharacteristics":
      return "BaselineCharacteristics"
    case "OutcomeMeasures":
      return "OutcomeMeasures"
    case "AdverseEvents":
      return "AdverseEvents"
    case "TrialCountries":
      return "TrialCountries"
    case "AgeRange":
      return "AgeRange"
    case "CopyContact":
      return "CopyContact"
    case "MultiSelect":
      return "MultiSelect"
    case "FreeMultiSelect":
      return "FreeMultiSelect"
    case "CopyTextArea":
      return "CopyTextArea"
    case "SingleCheckbox":
      return "SingleCheckbox"
    case "MemberStatesConcerned":
      return "MemberStatesConcerned"
    case "SelectTag":
      return "SelectTag"
    default:
      return "textarea"
  }
}
